import { getFromCookie } from './utils';

const getFromLocalstorage = () =>
  [...Array(localStorage.length).keys()].reduce((map, i) => {
    map[localStorage.key(i)] = localStorage.getItem(localStorage.key(i));
    return map;
  }, {});

const getAuthData = authDataKey => {
  const accountType = getFromCookie(authDataKey, 'accountType') || '';
  const dom = getFromCookie(authDataKey, 'dom') || '';
  const hasGov = getFromCookie(authDataKey, 'hasGov') || false;
  const loginType = `${hasGov ? 'gov' : ''}`;

  return { accountType, dom, loginType };
};

const getUrl = (versionSufix, isFallback) => {
  if (isFallback)
    return `${window.apw.APW_CONFIG_URL_FALLBACK}${window.apw.APW_ENV}-${window.apw.APW_ROOT_RULE}${versionSufix}`;

  return `${window.apw.APW_CONFIG_URL}${window.apw.APW_ENV}-${window.apw.APW_ROOT_RULE}${versionSufix}`;
};

export const FALLBACK_STATUS = [500, 502, 503, 504, 408, 404, 405];

const sendRequest = (url, state, accountType, loginType, dom) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onerror = () => {
      const error = new Error(`XHR error with status ${xhr.status}`);
      error.status = xhr.status;
      reject(error);
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(JSON.parse(xhr.responseText));
      } else {
        const error = new Error(`HTTP ${xhr.status}: ${xhr.statusText}`);
        error.status = xhr.status;
        reject(error);
      }
    };

    xhr.send(
      JSON.stringify({
        apw_state: state,
        apw_account_type: accountType,
        login_type: loginType,
        dom_account: dom,
        origin: window.location.host,
        path: window.location.pathname,
      }),
    );
  });

export const getConfig = async () => {
  const data = getFromLocalstorage();
  const state = 'DF';
  const authDataKey = window.apw.APW_AUTH_DATA_KEY || 'APW_OAUTH_USER_DATA';
  const { accountType, dom, loginType } = getAuthData(authDataKey);

  if (data.apw_mod_start === 'local' && 'apw_local_config' in data) {
    return Promise.resolve(JSON.parse(data.apw_local_config));
  }
  const check = window.apw.APW_CONFIG_URL && window.apw.APW_ENV && window.apw.APW_ROOT_RULE;

  if (!check)
    throw new Error(
      'Missing required configuration values: APW_CONFIG_URL, APW_ENV, or APW_ROOT_RULE',
    );

  const versionSufix = window.apw.APW_RULE_VERSION ? `/${window.apw.APW_RULE_VERSION}` : '';
  const fallbackUrl = getUrl(versionSufix, true);
  const url = getUrl(versionSufix);

  try {
    const result = await sendRequest(url, state, accountType, loginType, dom);
    return result;
  } catch (err) {
    if (FALLBACK_STATUS.includes(err.status)) {
      return sendRequest(fallbackUrl, state, accountType, loginType, dom);
    }
    throw err;
  }
};

export const getEnv = () => window.apw.APW_ENV;
